export const HTTP_HEADERS = {
  AppVersion: process.env.REACT_APP_VERSION
};

export default HTTP_HEADERS;
